/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  PutApiV1CourseregistrationEnrollmentCourseregistrationidSelectiveProcessTab202,
  PutApiV1CourseregistrationEnrollmentCourseregistrationidSelectiveProcessTab400,
  PutApiV1CourseregistrationEnrollmentCourseregistrationidSelectiveProcessTab401,
  PutApiV1CourseregistrationEnrollmentCourseregistrationidSelectiveProcessTab500,
  PutApiV1CourseregistrationEnrollmentCourseregistrationidSelectiveProcessTabMutationRequest,
  PutApiV1CourseregistrationEnrollmentCourseregistrationidSelectiveProcessTabMutationResponse,
  PutApiV1CourseregistrationEnrollmentCourseregistrationidSelectiveProcessTabPathParams,
} from "../../types/courseRegistrationEnrollmentController/PutApiV1CourseregistrationEnrollmentCourseregistrationidSelectiveProcessTab.ts";
import { courseRegistrationSaveSelectiveProcessRequestViewModelSchema } from "../courseRegistrationSaveSelectiveProcessRequestViewModelSchema.ts";

export const putApiV1CourseregistrationEnrollmentCourseregistrationidSelectiveProcessTabPathParamsSchema =
  z.object({
    courseRegistrationId: z.coerce.number().int(),
  }) as unknown as ToZod<PutApiV1CourseregistrationEnrollmentCourseregistrationidSelectiveProcessTabPathParams>;

/**
 * @description (Accepted) Requisição aceita.
 */
export const putApiV1CourseregistrationEnrollmentCourseregistrationidSelectiveProcessTab202Schema =
  z.any() as unknown as ToZod<PutApiV1CourseregistrationEnrollmentCourseregistrationidSelectiveProcessTab202>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const putApiV1CourseregistrationEnrollmentCourseregistrationidSelectiveProcessTab400Schema =
  z.any() as unknown as ToZod<PutApiV1CourseregistrationEnrollmentCourseregistrationidSelectiveProcessTab400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const putApiV1CourseregistrationEnrollmentCourseregistrationidSelectiveProcessTab401Schema =
  z.any() as unknown as ToZod<PutApiV1CourseregistrationEnrollmentCourseregistrationidSelectiveProcessTab401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const putApiV1CourseregistrationEnrollmentCourseregistrationidSelectiveProcessTab500Schema =
  z.any() as unknown as ToZod<PutApiV1CourseregistrationEnrollmentCourseregistrationidSelectiveProcessTab500>;

export const putApiV1CourseregistrationEnrollmentCourseregistrationidSelectiveProcessTabMutationRequestSchema =
  z.lazy(
    () => courseRegistrationSaveSelectiveProcessRequestViewModelSchema,
  ) as unknown as ToZod<PutApiV1CourseregistrationEnrollmentCourseregistrationidSelectiveProcessTabMutationRequest>;

export const putApiV1CourseregistrationEnrollmentCourseregistrationidSelectiveProcessTabMutationResponseSchema =
  z.lazy(
    () =>
      putApiV1CourseregistrationEnrollmentCourseregistrationidSelectiveProcessTab202Schema,
  ) as unknown as ToZod<PutApiV1CourseregistrationEnrollmentCourseregistrationidSelectiveProcessTabMutationResponse>;
